namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_layout_vert, {

		Includes: {
			position: 'absolute',
			left: '100px',
		},

		// pointerEvents: 'none', //transparent body

		Widget_head: {
			pointerEvents: 'auto',
			margin: {
				top: '-40px',
			},
		},

		Top_edge: { pointerEvents: 'auto' },
		Left_edge: { pointerEvents: 'auto' },
		Bottom_edge: { pointerEvents: 'auto' },
		Right_edge: { pointerEvents: 'auto' },
		Top_left_edge: { pointerEvents: 'auto' },
		Top_right_edge: { pointerEvents: 'auto' },
		Bottom_left_edge: { pointerEvents: 'auto' },
		Bottom_right_edge: { pointerEvents: 'auto' },
		Left_top_edge_ratio: { pointerEvents: 'auto' },
		Left_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_top_edge_ratio: { pointerEvents: 'auto' },
		Top_left_edge_ratio: { pointerEvents: 'auto' },
		Top_right_edge_ratio: { pointerEvents: 'auto' },
		Bottom_left_edge_ratio: { pointerEvents: 'auto' },
		Bottom_right_edge_ratio: { pointerEvents: 'auto' },

		// '[shm_hitalama_map_widget_float_selected]': {
		// 	true: {
		// 		Widget_head: {
		// 			outline: '1px solid var(--mol_theme_current)',
		// 			":hover": {
		// 				outline: '1px solid var(--mol_theme_current)',
		// 			},
		// 		},
		// 	},
		// },
		// '[shm_hitalama_map_widget_float_dragged]': {
		// 	true: {
		// 		Widget_head: {
		// 			outline: '1px solid var(--mol_theme_control)',
		// 			":hover": {
		// 				outline: '1px solid var(--mol_theme_control)',
		// 			},
		// 		},
		// 	},
		// },
		
		New_pos: {
			position: 'absolute',
			left: '1px',
			right: '1px',
			// outline: '2px var(--mol_theme_focus) dashed',
			// outline: '2px var(--mol_theme_focus) dashed',
			outlineOffset: '-2px',
			border: {
				radius: $mol_gap.round,
				top: {
					style: 'dashed',
					width: '2px',
					color: $mol_theme.current,
				},
			},
			backgroundColor: `color-mix(in srgb, var(--mol_theme_current) 10%, transparent);`,
			// backgroundColor: `hsla( calc( var(--mol_theme_hue) + 180deg ), 100%, 65%, 0.05 )`,
		},
		
		// Item: {
		// 	flex: {
		// 		direction: 'column',
		// 	},
		// 	// gap: '1.5rem',
		// },
		
		// List: {
		// 	flex: {
		// 		direction: 'column',
		// 	},
		// 	// gap: '1.5rem',
		// },

		// Widget_controls: {
		// 	background: {
		// 		color: $mol_theme.card,
		// 	},
		// },
		
		// Widget_delete: {
		// 	color: '#ff6666',
		// },
		
	} )
	
}
